class StripeLib {

  constructor() {
    let key = window.location.hostname === 'www.ptdefender.com'
      ? 'pk_live_lbbAapWtC7RjbE4kZj629qZd'
      : 'pk_test_FbaLkkOSfk9lwFGkMKQolXa7'
    this._stripe = window.Stripe(key)
    this._elements = this._stripe.elements()
  }

  createCard(mountElement, options = {}) {
    let card = this._elements.create('card', {
      base: {
        color: '#32325d',
        lineHeight: '18px',
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        fontSmoothing: 'antialiased',
        fontSize: '16px',
        '::placeholder': {
          color: '#aab7c4'
        }
      },
      invalid: {
        color: '#fa755a',
        iconColor: '#fa755a'
      },
      ...options
    })

    card.mount(mountElement)

    return card
  }

  async createToken(card) {
    let { token, error } = await this._stripe.createToken(card)
    if (error) throw error
    return token
  }
}

export default StripeLib
